import { Card, Heading, Inline, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { CarrierLogo } from '@eti/components';
import { css } from '@eti/styles';
import { getBoundTitle, getBoundType } from '../../../widgets/trip-details/utils/format';
import { getBoundInfo } from '../utils';
import type { TripType } from '../models';
import RouteInfo from '../../order-details/components/common/RouteInfo';

const carrierLogoStyles = css`
  height: 20px;
  width: auto;
`;

const getTitle = (index: number) => {
  return getBoundTitle(getBoundType(index), false);
};

interface OriginalTripProps {
  originalTrip: TripType;
}

const OriginalTrip = ({ originalTrip }: OriginalTripProps) => {
  const { t } = useTranslation();

  return (
    <Card data-testid="change-trip-original-trip">
      <Stack>
        <Heading level={2}>{t('ChangeTrip.OriginalTrip.Title')}</Heading>
        {originalTrip.bounds.map((bound, index) => {
          const boundInfo = getBoundInfo(bound.segments);

          return (
            <Stack key={`route-${boundInfo.origin}-${boundInfo.destination}`}>
              <Heading level={3}>{t(getTitle(index))}</Heading>
              <Inline>
                {boundInfo.marketingCarrierName && (
                  <CarrierLogo
                    className={carrierLogoStyles}
                    id={boundInfo.marketingCarrierCode}
                    imageAlt={boundInfo.marketingCarrierName}
                  />
                )}
                <Stack spacing={8}>
                  <RouteInfo
                    dataTestId={`change-trip-original-trip-bound-${index}`}
                    route={{
                      destination: {
                        cityName: boundInfo.destination,
                        cityCode: boundInfo.arrivalCode,
                      },
                      origin: {
                        cityName: boundInfo.origin,
                        cityCode: boundInfo.departureCode,
                      },
                      arrivedAt: boundInfo.arrivedAt,
                      departuredAt: boundInfo.departuredAt,
                    }}
                  />
                </Stack>
              </Inline>
            </Stack>
          );
        })}
      </Stack>
    </Card>
  );
};

export default OriginalTrip;
